<template lang="">
  <div class="">
    <div class="bg-white gWidth padding">
      <div class="search_box">
        <div class="search_ipt">
          <input
            type="text"
            @keydown="lylist"
            placeholder="请输入您要搜索的内容"
            v-model.trim="words"
            :class="
              search_list.length > 0 && !listShow
                ? 'no_btm_border'
                : 'btm_border'
            "
          />
          <ul class="search_ul" v-if="search_list.length > 0 && !listShow">
            <li
              v-for="item in search_list"
              :key="item.id"
              style="cursor: pointer;"
            >
              <span
                class="news_info"
                @click="changeWords(item)"
                style="width:60%;"
                >{{ item }}</span
              >
            </li>
          </ul>
        </div>
        <button type="button" class="search_btn" @click="lylist(2)">
          搜索
        </button>
      </div>
      <div class=" padding-bottom" v-if="listShow">
        <Lists
          :liebiaos="lylists"
          :totlePage="totlePage"
          @liebiao2="liebiao2"
        ></Lists>
      </div>
    </div>
  </div>
</template>
<script>
import { allsearch, get_sousuo_content } from "@/api/gxq";
import Lists from "../../components/Lists/Lists";
export default {
  name: "Search",
  components: {
    Lists,
  },
  data() {
    return {
      search_list: [],
      lylists: [],
      totlePage: 45,
      id: "",
      words: "",
      isShow: false,
      heights: "",
      listShow: false,
      isLoading: false,
    };
  },
  methods: {
    changeWords(item) {
      this.words = item;
      this.lylist(2);
    },
    getHeight() {
      var m_height = document.body.clientHeight - 200;
      this.heights = m_height + "px";
      // console.log(this.heights);
    },
    lylist(e, page) {
      if (e && e == 2) {
        //点击搜索按键
        if (!this.words) {
          this.lylists = [];
          return false;
        }
        this.listShow = true;
        this.getLists3(page);
      } else {
        setTimeout(() => {
          if (!this.words) {
            this.search_list = [];
            return false;
          }
          this.getLists2();
        }, 300);
        this.listShow = false;
      }
    },
    async getLists3(page) {
      const { data } = await allsearch({
        page: page ? page - 1 : 0,
        words: this.words,
      });
      this.lylists = data.data;
      this.totlePage = data.pages;
      this.isShow = true;
    },
    async getLists2() {
      const { data } = await get_sousuo_content({
        words: this.words,
      });
      this.search_list = data;
      this.isShow = true;
    },
    liebiao2(page) {
      this.lylist(2, page);
    },
  },
};
</script>

<style src="../../../vab/styles/searchs.css" scoped></style>
